import React, { PureComponent } from "react";
import { Loader, FormCheckbox, Card } from "ui-kit-ck-consultant";
import { Col, Row } from "react-flexbox-grid";
import moment from "moment";
import * as XLSX from "xlsx";

import ShowOptionsNGRA from "../../../components/general/ShowOptionsNGRA-v2";

import List from "../../../components/planning/planning/List";
import Export from "../../../components/planning/planning/Export";
import CalendarLeave from "../../../components/planning/planning/Calendar";
import DetailsDeclare from "../../../components/planning/planning/DetailsDeclare";

import { getUsers } from "../../../utils/general";
import axiosConfig from "../../../utils/axiosConfig";

import AuthContext from "../../../context/AuthContext";
import filterStore from "../../../stores/filterStore";

const absenceTypeOptions = [
  "Fermeture exceptionnelle",
  "Délégué(e) syndical(e)",
  "Maladie non professionnelle",
  "Récupération CSE",
  "Absence rémunérée",
  "Congé parental d'éducation",
  "Congés payés",
  "Absence TNS",
  "Congé pour enfant malade",
  "RTT",
  "Congés paternité",
  "Heures délégation suppléants",
  "Hors heures délégations",
  "Récupération",
  "Repos compensateur",
  "Absence injustifiée",
  "Heures délégation",
  "Absence pour évènement familial",
  "Congés maternité",
  "CPF (Compte Personnel de Formation)",
  "Accident du travail",
  "Congé sans solde",
  "RTT (FJ)",
  "Formation",
  "Congé paternité",
  "Congé maternité",
  "Congé supplémentaire de naissance",
  "Formation (TR)",
  "Formation (Ø TR)",
  "Maladie TNS",
  "Absence injustifiée en h",
  "Absence autorisée non rémunérée",
  "Absence autorisée payée (révision examen)",
  "Congé de présence parentale",
];

export default class Planning extends PureComponent {
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    const saved = filterStore.getState().getPageState("planning");
    if (saved) {
      // Merge defaults so types added after the state was saved stay visible
      saved.absenceTypes = {
        ...Object.fromEntries(absenceTypeOptions.map((type) => [type, true])),
        ...saved.absenceTypes,
      };
    }
    this.state = saved || {
      isLoad: false,
      // ShowOption state
      userOptions: [],
      network: 0,
      group: 0,
      region: 0,
      agency: 0,
      user: [],
      year: 0,
      // Current personn data
      dataPerPersonn: [],
      // Calendar state
      dataCalendar: [],
      dataHolidays: [],
      // List state
      //Download file
      dataDownload: [],
      isDownload: false,
      filename: "",
      header: [],
      absenceTypes: Object.fromEntries(
        absenceTypeOptions.map((type) => [type, true])
      ),
      dataValidate: [],
      dataPending: [],
      dataWaiting: [],
      //Pagination
      activePage: 1,
      tabLength: 20,
      total: 0,
    };
  }

  componentDidMount() {
    this.getUsers();
  }

  componentWillUnmount() {
    filterStore.getState().setPageState("planning", this.state);
  }

  getUsers = () => {
    let userType = [0, 1, 2, 3, 4, 5];
    if (this.context.role === 1) {
      userType = [1, 2, 3];
    } else if (this.context.role === 2) {
      userType = [4, 5];
    }

    getUsers(
      this.context.network,
      this.context.group,
      this.context.region,
      null,
      userType,
      true,
      (result) => {
        if (this.context.role < 1) {
          result = result.filter(
            (element) => element.value === this.context.id
          );
        }
        this.setState({
          userOptions: result,
          user: this.context.id,
        });
      },
      this.context.manageAgency
    );
  };

  handleDataChange = (data) => {
    filterStore.getState().setPageFilters("planning", data);
    this.setState(
      {
        network: data.network,
        group: data.group,
        region: data.region,
        agency: data.agency,
        user: data.userMultiples,
        year: data.year,
      },
      () => {
        this.getPlannings(true);
      }
    );
  };

  getPlannings(isValidate) {
    this.setState({ isLoad: true }, () => {
      axiosConfig("planning/get-planning", {
        data: {
          isValidate: isValidate,
          network: this.state.network,
          group: this.state.group,
          region: this.state.region,
          agency: this.state.agency,
          user: this.state.user,
          year: this.state.year,
          orderName: this.state.order ? this.state.order.name : null,
          orderDesc: this.state.order ? this.state.order.desc : null,
        },
      }).then((res) => {
        if (res.data.success) {
          if (isValidate) {
            const selectedTypes = Object.keys(this.state.absenceTypes).filter(
              (key) => this.state.absenceTypes[key]
            );
            const filteredData = res.data.data.filter((el) =>
              selectedTypes.includes(el.absenceType)
            );

            let dataPending = [];
            let dataWaiting = [];

            if (this.context.role === 1) {
              // RESP TECHNIQUE
              dataWaiting = filteredData.filter((el) => {
                return (
                  [0].includes(el.status) && [1, 2, 3].includes(el.userType)
                );
              });
            } else if (this.context.role === 2) {
              // RESP ADMINISTRATIF
              dataWaiting = filteredData.filter((el) => {
                return [0].includes(el.status) && [4, 5].includes(el.userType);
              });
            } else if (this.context.role > 2) {
              dataPending = filteredData.filter((el) => {
                return [0].includes(el.status);
              });
              // DRH - DIRIGEANT
              dataWaiting = filteredData.filter((el) => {
                return [1].includes(el.status);
              });
            }

            const dataValidate = filteredData.filter((el) => {
              return [2, 3].includes(el.status);
            });

            this.setState({
              dataValidate,
              dataPending,
              dataWaiting,
              dataCalendar: dataValidate.filter((el) => el.status === 2),
              dataHolidays: res.data.holidays,
              dataPerPersonn: filteredData.filter(
                (el) => el.userId === this.context.id
              ),
            });
          }
        } else {
        }
        this.setState({ isLoad: false });
      });
    });
  }

  getDataXLSX(month, absenceType) {
    this.setState({ isLoad: true }, () => {
      axiosConfig("planning/get-data-XLSX", {
        data: { ...this.getData(), month, absenceType },
      }).then((res) => {
        if (res.data.success) {
          if (res.data.data.length) {
            const header = [];
            if (absenceType !== "Formation") {
              header.push({
                dateInsert: "Date de la demande",
                userName: "Utilisateur",
                agency: "Agence",
                type: " Type de congés",
                monthOfDeparture: "Mois de départ",
                dateStart: "Date de départ",
                typeStart: "Type de départ",
                dateEnd: "Date de retour",
                typeEnd: "Type de retour",
                absenceDuration: "Durée",
                file: "Piéce jointe",
                status: "État",
                managerName: "Responsable",
                RH: "RH",
              });
            } else {
              header.push({
                dateInsert: "Date de la demande",
                userName: "Utilisateur",
                agency: "Agence",
                monthOfDeparture: "Mois de départ",
                dateStart: "Date de départ",
                dateEnd: "Date de retour",
                absenceDuration: "Durée",
                organization: "Organisme",
                type: "Type",
                RH: "Lieu",
                status: "État",
              });
            }

            const workBook = XLSX.utils.book_new();
            const workSheet = XLSX.utils.json_to_sheet([]);
            XLSX.utils.sheet_add_json(workSheet, header, {
              skipHeader: true,
              origin: "A1",
            });
            XLSX.utils.sheet_add_json(
              workSheet,
              res.data.data
                .map((element) =>
                  absenceType !== "Formation"
                    ? {
                        dateInsert: element.dateInsert,
                        userName: element.userName,
                        agency: element.agency,
                        type: element.type,
                        monthOfDeparture: element.monthOfDeparture,
                        dateStart: element.dateStart,
                        typeStart: element.typeStart,
                        dateEnd: element.dateEnd,
                        typeEnd: element.typeEnd,
                        absenceDuration: element.absenceDuration,
                        file: element.file,
                        status: element.status,
                        managerName: element.managerName,
                        RH: element.RH,
                      }
                    : {
                        dateInsert: element.dateInsert,
                        userName: element.userName,
                        agency: element.agency,
                        monthOfDeparture: element.monthOfDeparture,
                        dateStart: element.dateStart,
                        dateEnd: element.dateEnd,
                        absenceDuration: element.absenceDuration,
                        organization: element.organization,
                        type: element.type,
                        RH: element.RH,
                        status: element.status,
                      }
                )
                .filter((element) => element.status !== "Rejetée"),
              {
                skipHeader: true,
                origin: "A2",
              }
            );
            XLSX.utils.book_append_sheet(workBook, workSheet, "");
            XLSX.writeFile(
              workBook,
              `${absenceType ? absenceType : "absence"}_${moment().format(
                "YYYYMMDDHHmmss"
              )}.xlsx`
            );
            this.setState({ isLoad: false });
          } else {
            this.setState({ isLoad: false });
            alert(
              `${
                absenceType
                  ? "Pas de formation enregistrée pour ce mois-ci"
                  : "Pas d'absence enregistrée pour ce mois-ci"
              }`
            );
          }
        } else {
          this.setState({ isLoad: false });
        }
      });
    });
  }

  getDataPerUserXLSX(month, absenceType) {
    this.setState({ isLoad: true }, () => {
      axiosConfig("planning/get-data-per-user-XLSX", {
        data: { ...this.getData(), month, absenceType },
      }).then((res) => {
        if (res.data.success) {
          if (res.data.data) {
            const workBook = XLSX.utils.book_new();
            const workSheet = XLSX.utils.json_to_sheet([]);

            if (absenceType !== "Formation") {
              // Liste de tous les mois de l'année
              const months = [
                "Janvier",
                "Janvier Maladie",
                "Février",
                "Février Maladie",
                "Mars",
                "Mars Maladie",
                "Avril",
                "Avril Maladie",
                "Mai",
                "Mai Maladie",
                "Juin",
                "Juin Maladie",
                "Juillet",
                "Juillet Maladie",
                "Août",
                "Août Maladie",
                "Septembre",
                "Septembre Maladie",
                "Octobre",
                "Octobre Maladie",
                "Novembre",
                "Novembre Maladie",
                "Décembre",
                "Décembre Maladie",
              ];

              const header = [
                {
                  userName: "Utilisateur",
                  annualLeave: " Jours de congées annuel/sans solde",
                  sickLeave: "Jours d'arret maladie",
                  ...Object.fromEntries(months.map((month) => [month, month])),
                },
              ];

              XLSX.utils.sheet_add_json(workSheet, header, {
                skipHeader: true,
                origin: "A1",
              });

              const monthOrder = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ];

              res.data.data.forEach((data, index) => {
                const sortedMonthlyData = {};
                monthOrder.forEach((month) => {
                  sortedMonthlyData[month] = data.monthly[month];
                  sortedMonthlyData[`${month}Maladie`] =
                    data.monthly[`${month}Maladie`];
                });

                XLSX.utils.sheet_add_json(
                  workSheet,
                  [{ value: data.userName }],
                  {
                    skipHeader: true,
                    origin: `A${index + 3}`,
                  }
                );

                XLSX.utils.sheet_add_json(
                  workSheet,
                  [{ value: data.annualLeave }],
                  {
                    skipHeader: true,
                    origin: `B${index + 3}`,
                  }
                );

                XLSX.utils.sheet_add_json(
                  workSheet,
                  [{ value: data.sickLeave }],
                  {
                    skipHeader: true,
                    origin: `C${index + 3}`,
                  }
                );

                XLSX.utils.sheet_add_json(workSheet, [sortedMonthlyData], {
                  skipHeader: true,
                  origin: `D${index + 3}`,
                });
              });
            } else {
              const header = [
                "Utilisateur",
                "Jours de formation",
                "Janvier",
                "Fevrier",
                "Mars",
                "Avril",
                "Mai",
                "Juin",
                "Juillet",
                "Aout",
                "Septembre",
                "Octobre",
                "Novembre",
                "Decembre",
              ];

              XLSX.utils.sheet_add_json(
                workSheet,
                [{ ...Object.fromEntries(header.map((val) => [val, val])) }],
                {
                  skipHeader: true,
                  origin: "A1",
                }
              );

              res.data.data.forEach((data, index) => {
                XLSX.utils.sheet_add_json(
                  workSheet,
                  [
                    {
                      userName: data.userName,
                      total: data.total,
                      ...data.month,
                    },
                  ],
                  {
                    skipHeader: true,
                    origin: `A${index + 3}`,
                  }
                );
              });
            }

            XLSX.utils.book_append_sheet(workBook, workSheet, "Absences");

            XLSX.writeFile(
              workBook,
              `${absenceType ? absenceType : "absence"}_${moment().format(
                "YYYYMMDDHHmmss"
              )}.xlsx`
            );
            this.setState({ isLoad: false });
          } else {
            this.setState({ isLoad: false });
            alert("Pas d'absence par personnes enregistrée pour ce mois-ci");
          }
        } else {
          this.setState({ isLoad: false });
        }
      });
    });
  }

  setData(result) {
    if (result.success === true) {
      this.setState({ dataList: result.tabData, isLoad: false });
    } else {
      this.setState({ dataList: [], isLoad: false });
    }
  }

  handleTabClick = (idx) => {
    let dataList = this.state.dataList;
    if (dataList[idx].active === false) {
      dataList[idx].active = true;
    } else {
      dataList[idx].active = false;
    }
    this.setState({ dataList: dataList });
  };

  getData() {
    return {
      network: this.state.network,
      group: this.state.group,
      region: this.state.region,
      agency: this.state.agency,
      user: this.state.user,
      year: this.state.year,
      orderName: this.state.order ? this.state.order.name : null,
      orderDesc: this.state.order ? this.state.order.desc : null,
    };
  }

  handleAbsenceTypeChange = (e) => {
    const { name, checked } = e.target;
    this.setState(
      (prevState) => ({
        absenceTypes: {
          ...prevState.absenceTypes,
          [name]: checked,
        },
      }),
      () => {
        if (this.state.dataValidate.length > 0 || this.state.dataPending.length > 0 || this.state.dataWaiting.length > 0) {
          this.getPlannings(true);
        }
      }
    );
  };

  onSortClick = (order) => {
    this.setState({ order }, () => {
      this.getPlannings(true);
    });
  };

  updateDataList = (key, value) => {
    this.setState((prevState) => ({
      inputs: {
        ...prevState.dataList,
        [key]: value,
      },
    }));
  };

  render() {
    return (
      <>
        <Loader show={this.state.isLoad} />
        <DetailsDeclare title="Détail de l'absence" getData={this.getData} />
        <ShowOptionsNGRA
          initialFilters={filterStore.getState().getPageFilters("planning")}
          isChange={true}
          className={"mb-10 mb-20-xl"}
          onDataChange={this.handleDataChange}
          isYear={true}
          isUser={true}
          isUserMultiples={true}
          visibilityRole={this.props.visibilityRole}
          visibilityType={this.props.visibilityType}
          preloadRole={this.props.preloadRole}
          preloadType={this.props.preloadType}
          limitUserType={this.props.limitUserType}
          limitUserRole={this.props.limitUserRole}
          allUserRole={this.props.allUserRole}
          isAll={true}
          userType={[1, 2, 3, 4, 5]}
        />
        <Card className={"mb-10 mb-20-xl"}>
          <Row>
            <Col xs={12}>
              <p className="mb-5">
                <b>Type d'absence</b>
              </p>
            </Col>
            {absenceTypeOptions.map((type, idx) => (
              <Col key={idx} xs={6} md={4} lg={3}>
                <FormCheckbox
                  className="m-auto mr-5"
                  name={type}
                  checked={this.state.absenceTypes[type]}
                  onChange={this.handleAbsenceTypeChange}
                  text={type}
                />
              </Col>
            ))}
          </Row>
        </Card>
        <CalendarLeave
          className={"mb-10 mb-20-xl"}
          dataCalendar={this.state.dataCalendar}
          dataHolidays={this.state.dataHolidays}
        />
        {[1, 2, 3, 4].includes(this.context.role) ? (
          <Export
            getDataXLSX={(month, absenceType) =>
              this.getDataXLSX(month, absenceType)
            }
            getDataPerUserXLSX={(month, absenceType) =>
              this.getDataPerUserXLSX(month, absenceType)
            }
          />
        ) : null}
        {this.state.dataValidate.length > 0 && (
          <List
            userOptions={this.state.userOptions}
            onSortClick={(order) => this.onSortClick(order)}
            title={"Liste"}
            data={this.state.dataValidate.slice(
              (this.state.activePage - 1) * this.state.tabLength,
              this.state.activePage * this.state.tabLength
            )}
            updatePlannings={() => this.getPlannings(true)}
            className={"mb-10 mb-20-xl"}
            updateDataList={(key, value) => this.updateDataList(key, value)}
            //Pagination
            activePage={this.state.activePage}
            tabLength={this.state.tabLength}
            total={this.state.dataValidate.length}
            onPageChange={(page) => {
              this.setState({
                activePage: page,
              });
            }}
          />
        )}
      </>
    );
  }
}
